export default function Map() {
    return (
        <div className="w-full">
            <h3 className="font-bold text-2xl mb-4">Location</h3>
            <div className="aspect-w-16 aspect-h-9">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10799.999999999999!2d-121.19!3d47.26!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x549a6b3d0e0b9c3b%3A0xceb3c3f4e5d9d9b7!2sEaston%2C%20WA%2098925%2C%20USA!5e0!3m2!1sen!2sus!4v1620000000000!5m2!1sen!2sus"
                    width="100%"
                    height="600"
                    style={{ border: 0 }}
                    allowFullScreen={true}
                    loading="lazy"
                ></iframe>
            </div>
        </div>
    );
}